"use client";
import { useTranslations } from "next-intl";
import st from "./index.module.scss";

export default function NotFoundSearch() {
  const t = useTranslations("SearchModal");

  return (
    <div className="search-result-wrap">
      <div className={st.search_result__not}>
        <img
          className={st.search_result__not_img}
          src="/images/not-result-dark.png"
          alt="no-results"
          data-test={st.search_result__not_img}
        />
        <div className={st.search_result__not_title} data-test={st.search_result__not_title}>
          {t("not_found_title")}
        </div>
        <div className={st.search_result__not_subtitle} data-test={st.search_result__not_subtitle}>
          {t("not_found_description")}
        </div>
      </div>
    </div>
  );
}
